import React from "react";
import  { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import './classes/ManageBlogPost.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { Helmet } from 'react-helmet';
import { useLocation,useNavigate,useSearchParams } from 'react-router-dom';
import Loading from './Loading';

const columns = [
    {
        field: 'display_name',
        headerName: 'Title',
        headerClassName: 'super-app-theme--header',
        flex:1,
        minWidth: 130, 
        sortable: false,
        filterable: false,
        renderCell: (params) => (
            <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.display_name}
            </Link>
        ), 
    },
    {
        field: 'name',
        headerName: 'Name',
        headerClassName: 'super-app-theme--header',
        flex:1,  
        minWidth: 130, 
        sortable: false,
        filterable: false,
    },
    {
        
        field: 'title',
        headerName: 'Body Content',
        headerClassName: 'super-app-theme--header',
        flex:1,  
        minWidth: 300, 
        sortable: false,
        filterable: false,
         renderCell: (params) => (
    <div
      dangerouslySetInnerHTML={{ __html: params.value }}
    />
  ),
    },
    {
        field: 'updated_date',
        headerName: 'Updated Date',
        headerClassName: 'super-app-theme--header',
        flex:1,
        minWidth: 140,
        sortable: false,
        filterable: false,
    },
    {
        field: 'edit_link',
        headerName: 'Edit Link',
        headerClassName: 'super-app-theme--header',
        flex:1,
        minWidth: 80, 
        sortable: false,
        filterable: false,
        renderCell: (params) => (
            <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.linkText || 'Edit'}
            </Link>
        ),
    },
];

const ManageSuccessStories = () => {

    /* Pagination, filter config starts here */
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [isLoading, setIsLoading] = useState(true);
    const app_url = configData.APP_URL;
    const location  = useLocation();
    // const successDeleteMessage = location.state?.message; // Access the message

    const initialSuccessStoriesFilter = {
        field_name_value:'',
        title_value: '',
        body_value: '',
    };

    const [formData, setFormData] = useState(initialSuccessStoriesFilter);
    // const[successMessage,setSuccessMessage] = useState('');
    // useEffect(() => {
    //       if (successDeleteMessage) {
    //         setSuccessMessage(successDeleteMessage);
    //         window.history.replaceState({}, '');
    //       }
    //     }, [successDeleteMessage, location.state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Start at the top: SPA redirects (e.g. after Save) keep the previous page's scroll.
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        const fetchData = async () => {
        try {
        const response = await fetch(app_url+'successstory/managelist', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel,
            formData:formData
            }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        // console.log("Type of totalRowCount:", typeof data.data.totalRowCount);
        }  catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
    
        };

        fetchData();
    }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

    const handleSubmit = async (e) => {
        e.preventDefault(); // stop page reload
        console.log(formData);
        try {
            setIsLoading(true);
            const response = await fetch(app_url+'successstory/managelist/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
                sortModel,
                filterModel,
                formData:formData
                }),
            });
            const data = await response.json();
            
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        } 
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="manage-blog-container">
                            <Helmet><title>Manage Success Stories</title></Helmet>
                            {/* {successMessage && (
                                <div className="set-message-done">
                                    <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                                </div>
                            )} */}
                            <div>
                                <h1 style={{marginTop: "15px"}}>Manage Success Stories</h1>
                                <p><a href="/node/add/success-story">Add Success Story</a></p>
                                <form onSubmit={handleSubmit}>
                                    <div style={{display: "flex", gap: "8px", flexWrap: "wrap"}}>
                                        <div>
                                            <label htmlFor="edit-field-name-value">Name</label>
                                            <div>
                                                <input 
                                                    type="text" 
                                                    id="edit-field-name-value"
                                                    name="field_name_value" 
                                                    onChange={handleChange}
                                                    value={formData.field_name_value}
                                                    size={30} 
                                                    maxlength={128}
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="edit-title-value">Title</label>
                                            <div>
                                                <input
                                                    type="text"
                                                    id="edit-title-value"
                                                    name="title_value"
                                                    onChange={handleChange}
                                                    value={formData.title_value}
                                                    size={30}
                                                    maxlength={128}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <input type="submit" value="Apply" className="form-submit" />    
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="manage-blog-view-content">
                                <table className="manage-blog-view-table">
                                    <div style={{ width: '100%' }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            rowCount={rowCount}
                                            paginationMode="server"
                                            sortingMode="server"
                                            filterMode="server"
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            sortModel={sortModel}
                                            onSortModelChange={setSortModel}
                                            filterModel={filterModel}
                                            onFilterModelChange={setFilterModel}
                                            pageSizeOptions={[5, 10, 25,50]}
                                            getRowId={() => crypto.randomUUID()}
                                            getRowHeight={() => 'auto'}
                                            disableColumnFilter 
                                            // disableColumnResize={true}
                                        />
                                    </div>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar/>
                    </div>
                </div>
            )}
        </>
    );
};
export default ManageSuccessStories;